import { render, staticRenderFns } from "./KullaniciIzinleriForm.vue?vue&type=template&id=54f24480"
import script from "./KullaniciIzinleriForm.vue?vue&type=script&lang=ts"
export * from "./KullaniciIzinleriForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports